import { policyApi } from 'store/baseApi';

export const getReasons = (type: 'CANCEL' | 'VOID') =>
  policyApi.get(`policies/action-reasons?source=USERFORM&type=${type}`);

const api = { getReasons };

export default api;
